import configureStore from "./configureStore";
import history from "../constants/global-history";

const initialState = {};
export default configureStore(initialState, history);
